module.exports = __webpack_public_path__ + "media/application/images/ui/logo-peoples-choice-9382c37ba01402913de008596a9e635f.png";